import { getGitHubRepository, hasTicketProjects } from "@/domain/ticketing"
import { useIssueAndProjectDescription } from "@/organisms/Drawers/applications/triage/useTriage"

import type { VendorTicketingSystem } from "@/domain/ticketing"
import type { TicketModalPayload } from "./useTicketing.types"

// A system without projects files the ticket in the repository of the (first) Kodem issue;
// the backend rejects issues of different repositories
export const useTicketRepository = (
  system: VendorTicketingSystem,
  issueIds: TicketModalPayload["id"]
) => {
  const needsRepository = !hasTicketProjects(system)
  const issueId = needsRepository ? [issueIds].flat()[0] : undefined
  const [, { response }, isLoading] = useIssueAndProjectDescription(issueId)
  const repository = getGitHubRepository(response?.data?.resources)

  return {
    repository,
    isLoading,
    isMissing: needsRepository && !isLoading && !repository
  }
}
